var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('HeaderPage')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('MenuPage')],1),_c('el-container',[_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('FooterPage')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }